import React, { useContext } from "react";
import PropTypes from "prop-types";
import './css/formCampaña.css';
import AddParameters from "../Parametros/AddParameters";
import { CampContext } from "../../context/CampContext";
import Form from "./Form";


const FormCampaña = (props) => {
    const id = props.id;
    const {state} = useContext(CampContext)

    //RESET STATE

    return (
        <div>
           {state.form === true ? <Form id={id} /> : null } 
           {state.param === true ? <AddParameters /> : null } 
        </div>
    );
};

FormCampaña.propTypes = {
    match: PropTypes.object,
};

export default FormCampaña;



// WEBPACK FOOTER //
// ./src/scenes/campaña/FormCambaña.js